module.exports = __webpack_public_path__ + "img/menu_move.78dd88d2.svg";